<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">{{ editing ? 'Editar línea de gasto' : 'Nueva línea de gasto' }}</h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>{{ editing ? 'Datos de la línea de gasto' : 'Datos de la nueva línea de gasto' }}</h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Código *</label>
                    <input type="text" v-model="form.code" autocomplete="off" placeholder="Código"
                      class="custom-form-control" :class="{ 'custom-form-control-error': $v.form.code.$error }" />
                    <FormError v-if="$v.form.code.$error && !$v.form.code.required" message="Código es requerido" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nombre *</label>
                    <input type="text" v-model="form.name" autocomplete="off" placeholder="Nombre"
                      class="custom-form-control" :class="{ 'custom-form-control-error': $v.form.name.$error }" />
                    <FormError v-if="$v.form.name.$error && !$v.form.name.required" message="Nombre es requerido" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label>Descripción</label>
                    <input type="text" v-model="form.description" autocomplete="off" placeholder="Descripción"
                      class="custom-form-control" />
                  </div>
                </div>
              </div>
            </section>
            <div class="form-group-buttons text-right">
              <router-link :to="{ name: 'expense-line-list' }" class="button button-light">{{ editing ? 'Volver' : 'Cancelar' }}</router-link>
              <button class="button button-primary" type="submit">Guardar</button>
            </div>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError } from 'wize-admin'
import { ExpenseLineService } from '@/core/services'
import { required } from 'vuelidate/lib/validators'

export default {
  components: { FormError },
  data() {
    return { form: { code: null, name: null, description: null }, editing: false }
  },
  validations: { form: { code: { required }, name: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        let response
        if (!this.editing) response = await ExpenseLineService.save(this.form)
        else response = await ExpenseLineService.update(this.$route.params.id, this.form)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) {
          this.$router.push({ name: 'expense-line-edit', params: { id: response.payload.id } })
          this.editing = true
        }
      } catch (ex) {
        console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar')
      } finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const resp = await ExpenseLineService.get(id)
        this.form = { ...resp.payload }
        this.editing = true
      } catch (e) {
        console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar')
        this.$router.push({ name: 'expense-line-list' })
      } finally { this.$store.dispatch('app/loading', false) }
    },
  },
  created() { if (this.$route.params.id) this.load(this.$route.params.id) },
}
</script>
